import {
    GetEntitiesRequest,
    SummaryReportCriteria,
    ExtraReportDetailCriteria,
    BudgetVarianceFormatOutputCriteria,
} from './Manager/report.manager.model';

export class PsrRequest extends GetEntitiesRequest {
    reportTitle: string;
    startYearValue: number;
    endYearValue: number;
    propertyTypes: number[];
    includeEstAssessment: boolean;
    includeOnlySitesUnderAppeal: boolean;
    outputFormat: number;
    psrReportType: number;
    includeDisclaimer: boolean;
}

export class MaarRequest extends GetEntitiesRequest {
    reportTitle: string;
    YearValue: number;
    propertyTypes: number[];
    includeAllCompanies: boolean;
}

export class BudgetRequest extends GetEntitiesRequest {
    reportTitle: string;
    budgetYear: number;
    budgetYearString: string; // calculated for jsreport
    //includePPPropertyType: boolean;
    propertyTypes: number[];
    minimumDetailYearsShown: number;
    outputFormat: number;
    currCompanyBudgetID: number;
    priorCompanyBudgetID: number;
    budgetBasis: Core.CompanyBudgetBasisEnum;
    detailReportOptions: ExtraReportDetailCriteria;
    summaryReportOptions: SummaryReportCriteria;
    includeDisclaimer: boolean;
}

export class BudgetVarianceReportingRequest extends GetEntitiesRequest {
    constructor() {
        super();
        this.formatOutput = new BudgetVarianceFormatOutputCriteria();
        this.includeDisclaimer = true;
    }

    reportTitle: string;
    formatOutput: BudgetVarianceFormatOutputCriteria;
    includeDisclaimer: boolean;
}

export class ProgressStatusRequest extends GetEntitiesRequest {
    reportTitle: string;
    startYearValue: number;
    endYearValue: number;
    siteStatus: number;
    propertyTypes: number[];
}

export class SiteRequest extends GetEntitiesRequest {
    reportTitle: string;
    orderBy: number[];
    startYearValue: number;
    endYearValue: number;
    numberOfYearsToInclude: number;
    propertyTypes: number[];
    detailReportOptions: ExtraReportDetailCriteria;
    includeDisclaimer: boolean;
}

export class UserActivityRequest extends GetEntitiesRequest {
    reportTitle: string;
    loginDateBegin: Date;
    loginDateEnd: Date;
    onlyActiveUsers: boolean;
    includeUsersWithoutLogin: boolean;
    outputFormat: number;
    includeInternalUsers: boolean;

    showUserName: boolean;
    showContactTitle: boolean;
    showLoginDates: boolean;
    showLoginDayCount: boolean;
    showLastPasswordChange: boolean;

    userAccessReportLimitByLoginDate: Core.UserAccessReportLimitByLoginDateEnum;
}

export class UserAccessRequest extends GetEntitiesRequest {
    reportTitle: string;
    loginDateBegin: Date;
    loginDateEnd: Date;
    onlyActiveUsers: boolean;
    includeUsersWithoutLogin: boolean;
    outputFormat: number;
    includeInternalUsers: boolean;

    showUserName: boolean;
    showContactTitle: boolean;
    showLoginDates: boolean;
    showLoginDayCount: boolean;
    showLastPasswordChange: boolean;

    selectedUserId: System.Guid;
    userAccessReportStartWith: Core.UserAccessReportStartWithEnum;
    userAccessReportLimitByLoginDate: Core.UserAccessReportLimitByLoginDateEnum;
}

export class UserCSRRequest extends GetEntitiesRequest {
    reportTitle: string;
    selectedUserId: System.Guid;
}

export class AppealListReportRequest extends GetEntitiesRequest {
    taskIds: number[];
}

export class SupportInstanceEscalationActivityReportRequest extends GetEntitiesRequest {
    instanceIds: number[];
    contactIds: number[];
    escalationDateBegin: Date;
    escalationDateEnd: Date;
    outputFormat: number;
    anyEscalationDates: boolean;
    escalationGroupBy: Core.SupportInstanceEscalationActivityReportGroupByEnum;
}

export class ValueRequest extends GetEntitiesRequest {
    reportTitle: string;
    taxYear: number;
    propertyTypes: number[];
    showExemptions: boolean;
    showAllParcels: boolean;
    outputFormat: number;
    paperSize: number;
    orderBy: number;
    filingDeadlineStart: Date;
    filingDeadlineEnd: Date;
    nodBatchNumber: string;
    siteManagers: number[];
}

export class TaxSavingsRequest extends GetEntitiesRequest {
    reportTitle: string;
    taxYear: number;
    propertyTypes: number[];
    filingDeadlineStart: Date;
    filingDeadlineEnd: Date;
    isPreliminary: boolean;
    paperSize: number;
    orderBy: number;
}
